// Eye Repair Treatment — content from the live Riversol PDP.
const P = "https://cdn.shopify.com/s/files/1/0821/1399/products";
const F = "https://cdn.shopify.com/s/files/1/0821/1399/files";

export const EYE_REPAIR = {
  logo: "https://www.riversol.com/cdn/shop/files/Riversol_Logo_2026.svg?v=1770147445&width=200",
  productThumb: `${P}/eye-repair.png?v=1776097214`,

  // Comparison-section visibility flags (used by PdpLayout).
  showLightComparison: true,
  showBlueComparison: false,

  category: "Bestseller · Eye Treatment",
  titleLines: ["Eye Repair Treatment"],
  titleNoWrap: true,
  routineStep: {
    label: "Step 3 / Hydration",
    icons: [
      { src: "https://www.riversol.com/cdn/shop/files/icon-sundim.png?v=1770857817&width=48", alt: "Day" },
      { src: "https://www.riversol.com/cdn/shop/files/icon-moon.png?v=1770857826&width=48", alt: "Night" },
    ],
  },
  rating: 4.6,
  reviewCount: 1300,
  price: { regular: "$59.00", member: "$53.10" },
  promo: "10% off with Riversol+ Membership",
  shortDescription:
    "Our best-selling creamy eye treatment helps reduce puffiness, dark circles & crow's feet. An advanced antioxidant and multi-peptide blend supports smoother, brighter skin in the eye area.",
  shipping: "Free shipping on orders over $69",
  returns: "30 day returns",
  whenToUse: "How to use: After cleansing, apply 1 small pump along the orbital bone, outer corner and under-eye area. Wait 2 minutes to absorb before makeup.",
  perOrder: "Use within 12 months of opening.",
  ctaLabel: "Add to cart",
  variants: [
    { id: "30ml", label: "30mL", detail: "In stock", price: "$59.00" },
  ],
  defaultVariant: "30ml",

  plans: [
    { id: "membership", title: "Riversol+ Membership", subtitle: "10% off every order + free shipping & member perks", price: "$54.00", compareAt: "$59.00", unit: "CAD", badge: "Most popular", cta: "Join & add to cart", benefits: ["10% off every order, automatically", "Free shipping on every order", "Early access to new products & a birthday gift"], gifts: [
      {
        image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Eye_Repair_Treatment.jpg?v=1776098164",
        label: "+ Free Gentle Cleanser",
        meta: "with first order (worth $34)",
      },
      {
        image: "https://cdn.shopify.com/s/files/1/0821/1399/products/aa-serum.png?v=1776095507",
        label: "+ Free Anti-Aging Reparative Serum",
        meta: "with third order (worth $79)",
      },
    ], learnMore: { label: "How Riversol+ works", href: "https://www.riversol.com/pages/riversol_plus" } },
    { id: "subscribe", title: "Delivered every month", subtitle: "Subscribe & save — skip or cancel anytime", price: "$55.00", compareAt: "$59.00", unit: "CAD / mo", badge: "Auto-refill", cta: "Subscribe & save", benefits: ["Auto-delivered monthly — never run out", "Skip, swap or cancel anytime", "Locked-in price below one-time"] },
    { id: "onetime", title: "One-time purchase", subtitle: "Ships once, no commitment", price: "$59.00", compareAt: null, unit: "CAD", badge: null, cta: "Add to cart" },
  ],
  defaultPlan: "membership",
  anniversaryOffer: { label: "Anniversary offer", text: "Get $38 off orders $75+ with code", code: "14YEARS" },

  facts: {
    anchor: "actives-section",
    rows: [
      { label: "Targets", value: "Eye Bags, Puffiness, Signs of Aging, Dark Circles" },
      { label: "Suited to", value: "Normal to Dry, Combination, Very Dry, Oily" },
      { label: "Texture", value: "Cream" },
      { label: "Lasts", value: "3 months (30mL)" },
      { label: "Key ingredients", value: "Matrixyl + Haloxyl Peptide Complex, Hinokitiol (Beta-T), Stabilized Vitamin C, Vitamin E", link: true },
    ],
  },

  gallery: [
    { src: `${P}/eye-repair.png?v=1776097214`, alt: "Eye Repair Treatment product", label: "Product" },
    { src: `${F}/Eye_Repair_Treatment.jpg?v=1776098164`, alt: "Eye Repair Treatment cream texture", label: "Texture" },
    { src: `${F}/1_e9d39bcd-f49e-40f2-85d6-1532041a33ad.jpg?v=1776097203`, alt: "Eye Repair Treatment detail", label: "Detail" },
    { src: `${F}/3_aee70b69-f813-4b08-8b79-31e5934f0344.png?v=1776097209`, alt: "Eye Repair Treatment key ingredients", label: "Actives" },
    { src: `${F}/Option2_1.png?v=1776098169`, alt: "Eye Repair Treatment benefits", label: "Benefits" },
    { src: `${P}/EyeTreatment-KV6sm.png?v=1776097211`, alt: "Eye Repair Treatment key visual", label: "Key visual" },
  ],

  marquee: [
    "Matrixyl · Palmitoyl Pentapeptide-4", "Hinokitiol · Beta-T", "Stabilized Vitamin C", "Multi-Peptide Blend",
    "Fragrance-Free", "Dermatologist-Developed", "For Sensitive Skin", "Reduces Puffiness",
  ],

  ugc: {
    heading: "Riversol in Action",
    videos: [
      { id: "6707819debae4417a2990f0a1b9730ce", thumb: "https://www.riversol.com/cdn/shop/files/preview_images/6707819debae4417a2990f0a1b9730ce.thumbnail.0000000000.jpg?v=1781381205&width=800", video: "https://www.riversol.com/cdn/shop/videos/c/vp/6707819debae4417a2990f0a1b9730ce/6707819debae4417a2990f0a1b9730ce.HD-720p-3.0Mbps-86478555.mp4?v=0" },
      { id: "ed6efc4b6f0f4be1b72ed0a865cfc660", thumb: "https://www.riversol.com/cdn/shop/files/preview_images/ed6efc4b6f0f4be1b72ed0a865cfc660.thumbnail.0000000000.jpg?v=1781381205&width=800", video: "https://www.riversol.com/cdn/shop/videos/c/vp/ed6efc4b6f0f4be1b72ed0a865cfc660/ed6efc4b6f0f4be1b72ed0a865cfc660.HD-720p-1.6Mbps-86478567.mp4?v=0" },
      { id: "4c038977d26547408999f4e1fb48a347", thumb: "https://www.riversol.com/cdn/shop/files/preview_images/4c038977d26547408999f4e1fb48a347.thumbnail.0000000000.jpg?v=1773956868&width=800", video: "https://www.riversol.com/cdn/shop/videos/c/vp/4c038977d26547408999f4e1fb48a347/4c038977d26547408999f4e1fb48a347.HD-720p-1.6Mbps-78302330.mp4?v=0" },
      { id: "72bd9868884948778c77cf98530fb4f1", thumb: "https://www.riversol.com/cdn/shop/files/preview_images/72bd9868884948778c77cf98530fb4f1.thumbnail.0000000000.jpg?v=1772641115&width=800", video: "https://www.riversol.com/cdn/shop/videos/c/vp/72bd9868884948778c77cf98530fb4f1/72bd9868884948778c77cf98530fb4f1.HD-1080p-2.5Mbps-77141232.mp4?v=0" },
      { id: "610be86236774523b276bd7efa018af8", thumb: "https://www.riversol.com/cdn/shop/files/preview_images/610be86236774523b276bd7efa018af8.thumbnail.0000000000.jpg?v=1773956866&width=800", video: "https://www.riversol.com/cdn/shop/videos/c/vp/610be86236774523b276bd7efa018af8/610be86236774523b276bd7efa018af8.HD-720p-1.6Mbps-78302326.mp4?v=0" },
    ],
  },

  storyA: {
    eyebrow: "The targeted eye treatment",
    title: "Brighter, Smoother, Firmer",
    body: "Our targeted eye treatment is formulated to visibly brighten, smooth, and firm the delicate eye area. Powered by Matrixyl, peptides, stabilized vitamin C, and hinokitiol, it targets the look of dark circles, puffiness, and fine lines with a lightweight, fast-absorbing texture. After cleansing, a single small pump dotted along the orbital bone and under-eye area sinks in within two minutes — leaving skin comfortable, hydrated and ready for makeup.",
    indicators: [
      { icon: "sun", label: "Morning & night" },
      { icon: "clock", label: "2 min to absorb" },
      { icon: "feather", label: "Lightweight texture" },
    ],
    image: `${F}/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698`,
    imageAlt: "Eye Repair Treatment lifestyle",
    detailImage: `${F}/Eye_Repair_Treatment.jpg?v=1776098164`,
    detailAlt: "Eye Repair Treatment texture close-up",
  },

  collage: {
    eyebrow: "Multi-peptide, one treatment",
    headline: "Targeted care for the delicate eye area.",
    body: "An advanced antioxidant and multi-peptide blend — Matrixyl, peptides, stabilized vitamin C and hinokitiol — works together in a lightweight, fast-absorbing texture to help brighten, smooth and firm.",
    centerImage: `${P}/eye-repair.png?v=1776097214`,
    centerAlt: "Eye Repair Treatment product",
    topImage: `${F}/Eye_Repair_Treatment.jpg?v=1776098164`,
    topAlt: "Eye Repair Treatment texture",
    leftImage: `${F}/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698`,
    leftAlt: "Eye Repair Treatment in use",
    rightImage: `${P}/eye-repair.png?v=1776097214`,
    rightAlt: "Eye Repair Treatment product",
    twoBanners: true,
  },

  storyB: {
    eyebrow: "Dermatologist-developed",
    titleLines: ["Made for Sensitive Skin,", "by a Dermatologist"],
    p1: "Riversol products are dermatologist-developed for sensitive skin. Dr. Jason Rivers first created Riversol for patients who struggled to find skincare that delivered results without unnecessary irritation.",
    p2: "That same philosophy guides the Eye Repair Treatment — fragrance-free, paraben-free and made with low-irritant ingredients chosen to support comfort in the most delicate area of the face.",
    personName: "Dr. Jason Rivers",
    personRole: "Founder · Board-certified dermatologist",
    personInitials: "Dr.\nRivers",
    image: `${F}/Dr._Rivers_1.png?v=1774575652`,
    imageAlt: "Dr. Jason Rivers",
    badgeBig: "Beta-T",
    badgeText: "Riversol's signature hinokitiol antioxidant, from the Pacific red cedar.",
    imageRight: false,
  },

  actives: {
    eyebrow: "What's inside",
    titleLines: ["Actives that target", "the eye area"],
    intro: "A multi-peptide and antioxidant blend, chosen to visibly brighten, smooth and firm the delicate skin around the eyes — without unnecessary irritation.",
    items: [
      { n: "01", cat: "Star Active", name: "Matrixyl (Palmitoyl Pentapeptide-4)", benefit: "A multi-peptide that supports smoother-looking skin and the appearance of firmness around the eye." },
      { n: "02", cat: "Peptide Support", name: "Palmitoyl Oligopeptide", benefit: "Works alongside Matrixyl to help refine the look of fine lines and crow's feet." },
      { n: "03", cat: "Signature Antioxidant", name: "Hinokitiol (Beta-T)", benefit: "Riversol's signature antioxidant from the Pacific red cedar — helps even the look of tone and brighten." },
      { n: "04", cat: "Brightening", name: "Stabilized Vitamin C", benefit: "Aminopropyl Ascorbyl Phosphate — an antioxidant that helps brighten the look of dark circles and dullness." },
      { n: "05", cat: "Dark-Circle Complex", name: "Hesperidin Methyl Chalcone + Chrysin", benefit: "Helps reduce the look of under-eye puffiness and shadowing." },
      { n: "06", cat: "Comfort & Moisture", name: "Shea Butter + Vitamin E", benefit: "Nourishes and helps keep the delicate eye area soft and comfortable." },
    ],
  },

  clinical: {
    eyebrow: "Clinically studied",
    titleLines: ["Visible results,", "backed by testing."],
    cols: 3,
    animate: true,
    stats: [
      { value: "87%", num: 87, suffix: "%", label: "experienced more hydrated skin" },
      { value: "81%", num: 81, suffix: "%", label: "noticed fewer fine lines and wrinkles" },
      { value: "1,300+", num: 1300, suffix: "+", label: "verified customer reviews" },
    ],
    disclaimer: "Clinical results based on studies of key active ingredients (22 participants). Review count reflects verified Judge.me reviews.",
  },

  benefits: {
    eyebrow: "What it does",
    titleLines: ["Depuffs, brightens,", "smooths."],
    image: `${P}/EyeTreatment-KV6sm.png?v=1776097211`,
    imageAlt: "Eye Repair Treatment key visual",
    items: [
      "Minimize the look of puffiness",
      "Brighten dark circles",
      "Smooth fine lines and crow's feet",
      "Refine overall eye-area texture",
    ],
  },

  why: {
    eyebrow: "Riversol vs. others",
    title: "Why Riversol Is Different",
    items: [
      "Dermatologist-developed for sensitive skin",
      "Fragrance-free & paraben-free",
      "Signature hinokitiol (Beta-T) antioxidant",
      "Multi-peptide + stabilized Vitamin C blend",
      "Hypoallergenic, low-irritant formula",
      "Lightweight, fast-absorbing texture",
    ],
    comparison: [
      { feature: "Dermatologist-developed", desc: "By Dr. Rivers, combining clinical expertise with proven skincare science" },
      { feature: "Unique antioxidant blend", desc: "" },
      { feature: "Photostable Vitamin C", desc: "A light-resistant form of Vitamin C that helps improve radiance and even skin tone" },
      { feature: "Hinokitiol antioxidant support", desc: "Riversol's signature antioxidant hinokitiol helps fight free radicals for healthier-looking skin" },
      { feature: "Sensitive skin friendly", desc: "Formulated with sensitive skin in mind" },
      { feature: "Made in Canada", desc: "Canadian-made quality you can trust" },
    ],
  },

  reviews: { eyebrow: "Loved by real skin", title: "Customer stories" },

  alsoLove: {
    eyebrow: "Complete the ritual",
    title: "You may also love",
    products: [
      { name: "Anti-Aging Reparative Serum", tag: "Bestseller", image: `${P}/aa-serum.png?v=1776095507`, rating: 4.7, reviews: 2100, price: "$79.00", compareAt: null, variants: ["30 mL", "50 mL"], colors: [] },
      { name: "Daily Moisturizing Cream", tag: null, image: `${P}/dmc_8215c1a3-320f-40e2-8cda-af33d45a4928.png?v=1776098827`, rating: 4.8, reviews: 1560, price: "$49.00", compareAt: null, variants: ["50 mL"], colors: [] },
      { name: "Gentle Cleanser", tag: "Editor's pick", image: `${F}/Eye_Repair_Treatment.jpg?v=1776098164`, rating: 4.6, reviews: 890, price: "$34.00", compareAt: null, variants: ["130 mL"], colors: [] },
      { name: "Advanced Correcting Cream", tag: "New", image: `${P}/EyeTreatment-KV6sm.png?v=1776097211`, rating: 4.9, reviews: 420, price: "$99.00", compareAt: "$110.00", variants: ["30 mL", "50 mL"], colors: ["#f6e7d8", "#e6cbb2", "#c9a985"] },
      { name: "Antioxidant Enhance Serum", tag: null, image: `${F}/3_aee70b69-f813-4b08-8b79-31e5934f0344.png?v=1776097209`, rating: 4.7, reviews: 615, price: "$69.00", compareAt: null, variants: ["30 mL"], colors: [] },
      { name: "Facial Toner", tag: null, image: `${F}/1_e9d39bcd-f49e-40f2-85d6-1532041a33ad.jpg?v=1776097203`, rating: 4.5, reviews: 480, price: "$29.00", compareAt: null, variants: ["130 mL"], colors: [] },
      { name: "Anti-Aging Trio", tag: "Bundle · Save 15%", image: `${F}/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698`, rating: 4.9, reviews: 340, price: "$149.00", compareAt: "$176.00", variants: ["Full set"], colors: [] },
      { name: "Micro-Exfoliating Cleanser", tag: null, image: `${F}/Option2_1.png?v=1776098169`, rating: 4.6, reviews: 720, price: "$39.00", compareAt: null, variants: ["130 mL"], colors: [] },
    ],
  },

  highlights: {
    heading: "Skincare Facts",
    items: [
      { label: "Dermatologist-Formulated", icon: "https://www.riversol.com/cdn/shop/files/icon-testing.svg?width=48" },
      { label: "Fragrance-free", icon: "https://www.riversol.com/cdn/shop/files/icon-fragrance-free.svg?width=48" },
      { label: "Hypoallergenic", icon: "https://www.riversol.com/cdn/shop/files/icon-feather.svg?width=48" },
      { label: "Non-comedogenic", icon: "https://www.riversol.com/cdn/shop/files/icon-clog.svg?width=48" },
      { label: "Vegan", icon: "https://www.riversol.com/cdn/shop/files/icon-vegan.svg?width=48" },
      { label: "Cruelty-free", icon: "https://www.riversol.com/cdn/shop/files/icon-cruelty-free.svg?width=48" },
      { label: "Made In Canada", icon: "https://www.riversol.com/cdn/shop/files/icon-maple-leaf.svg?width=48" },
    ],
  },

  details: {
    eyebrow: "The details",
    titleLines: ["Everything else", "you need to know"],
    big: true,
    showClinical: false,
    howTo: [
      "After cleansing, use 1 small pump of eye cream.",
      "Dot the eye cream along the orbital bone, outer corner and under-eye areas.",
      "Do not apply to the eyelid or close to the actual eye, as the product may migrate into the eyes or lash line, potentially causing irritation or clogged oil glands.",
      "Gently pat in.",
      "Wait 2 minutes for Eye Repair Treatment to sink in and fully absorb before applying makeup to the area.",
      "Use within 12 months of opening.",
    ],
    ingredients: "Water/Eau, Caprylic/Capric Triglycerides, Propylene Glycol, Shea Butter, Polysorbate 60, Cyclopentasiloxane, Cyclotetrasiloxane, Dimethiconol, Glycerin, Butylene Glycol, Propylene Glycol Alginate, Hinokitiol, Palmitoyl Pentapeptide-4, Hesperidin Methyl Chalcone, N-Hydroxysuccinimide, Chrysin, Tocopheryl Acetate, Sodium Hydroxide, Caprylyl Glycol, Phenoxyethanol, Sodium Tocopheryl Phosphate, Sodium Lauriminodipropionate, Polysorbate 20, Xanthan Gum, Sodium Citrate, Alcohol, Palmitoyl Oligopeptide, Aminopropyl Ascorbyl Phosphate, Steareth-20, Carbomer, Tetrasodium EDTA, Citric Acid, Sorbic Acid.",
  },

  faq: {
    eyebrow: "Questions, answered",
    title: "Frequently asked",
    items: [
      { q: "What is Hinokitiol (Beta-T)?", a: "Hinokitiol (Beta-T) is our signature antioxidant found in the Pacific red cedar. Studied for decades for its natural antibiotic, antioxidant, anti-inflammatory and other natural skin-revitalizing properties, hinokitiol helps even skin tone, reduce the look of sun damage and help correct dark spots." },
      { q: "Is this suitable for sensitive skin?", a: "Yes. Riversol products are dermatologist-developed for sensitive skin. Dr. Jason Rivers first created Riversol for patients who struggled to find skincare that delivered results without unnecessary irritation. That same philosophy guides our fragrance-free, paraben-free formulas, made with low-irritant ingredients chosen to support skin comfort." },
      { q: "Can I use this on my eyelids?", a: "We recommend avoiding the eyelids, as product can migrate into the eyes or lash line and may lead to irritation or clogged oil glands. This applies to any moisturizing skincare product, not just eye cream." },
      { q: "How long should I wait before applying another product?", a: "In general, wait 2 minutes before applying additional skincare or makeup. Giving Eye Repair Treatment time to fully absorb helps maximize both immediate and long-term results." },
    ],
  },

  routine: {
    eyebrow: "Build the ritual",
    title: "Complete Your Routine",
    lifestyleImage: `${F}/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698`,
    lifestyleAlt: "Complete your routine",
    products: [
      { name: "Anti-Aging Reparative Serum", reason: "Apply before eye cream to support the look of firmness across the whole face.", price: "$79.00", image: "https://cdn.shopify.com/s/files/1/0821/1399/products/aa-serum.png?v=1776095507" },
      { name: "Daily Moisturizing Cream", reason: "Lock in hydration and extend comfort after your eye treatment.", price: "$49.00", image: "https://cdn.shopify.com/s/files/1/0821/1399/products/dmc_8215c1a3-320f-40e2-8cda-af33d45a4928.png?v=1776098827" },
      { name: "Gentle Cleanser", reason: "Start the routine with a fragrance-free cleanser that respects sensitive skin around the eyes.", price: "$34.00", image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Eye_Repair_Treatment.jpg?v=1776098164" },
      { name: "Facial Toner", reason: "Prep skin before serum and eye treatment for deeper absorption and even radiance.", price: "$29.00", image: "https://cdn.shopify.com/s/files/1/0821/1399/products/EyeTreatment-KV6sm.png?v=1776097211" },
      { name: "Antioxidant Enhance Serum", reason: "Layer beneath moisturizer to reinforce the skin barrier and boost overall radiance day and night.", price: "$69.00", image: "https://cdn.shopify.com/s/files/1/0821/1399/files/3_aee70b69-f813-4b08-8b79-31e5934f0344.png?v=1776097209" },
      { name: "Micro-Exfoliating Cleanser", reason: "Weekly refresh — gently sweeps away dull surface skin so eye actives absorb better.", price: "$39.00", image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Option2_1.png?v=1776098169" },
    ],
  },

  final: {
    eyebrow: "Bright, refreshed eyes",
    titleLines: ["Eye Repair", "Treatment"],
    image: `${P}/eye-repair.png?v=1776097214`,
    imageAlt: "Eye Repair Treatment",
    imageMode: "contain",
  },
};

export default EYE_REPAIR;
